import { useNavigate } from 'react-router-dom'
import { useDailyQuote } from '../../utils/useDailyQuote'
import { useAppSelector } from '../../store/hooks'
import { selectQuoteCount } from '../../store/selectors'
import QuoteCard from '../../components/Quote/QuoteCard'
import styles from './Home.module.css'

function Home() {
  const navigate = useNavigate()
  const { quote, isLoading, refresh } = useDailyQuote()
  const quoteCount = useAppSelector(selectQuoteCount)

  // No quotes yet - show empty state
  if (quoteCount === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📝</div>
          <h2 className={styles.emptyTitle}>No quotes yet</h2>
          <p className={styles.emptyText}>
            Add your first motivational quote to get started
          </p>
          <button
            className={styles.primaryButton}
            onClick={() => navigate('/quotes')}
          >
            Add Your First Quote
          </button>
        </div>
      </div>
    )
  }

  // Loading state
  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Loading today's motivation...</div>
      </div>
    )
  }

  // Show daily quote
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.label}>Today's Motivation</p>

        {quote && <QuoteCard quote={quote} variant="large" />}

        <div className={styles.actions}>
          <button className={styles.refreshButton} onClick={refresh}>
            <span className={styles.refreshIcon}>🔄</span>
            Show Another Quote
          </button>
        </div>

        <div className={styles.stats}>
          <p className={styles.statsText}>
            You have <strong>{quoteCount}</strong> quote
            {quoteCount !== 1 ? 's' : ''} in your collection
          </p>
        </div>
      </div>
    </div>
  )
}

export default Home
